import { DrawRewardTypeEnum } from "@/api/backofficeRest/generated/model"
import { IDrawReward } from "./drawReward.types"

export class DrawReward implements IDrawReward {
  constructor(
    public id: string,
    public name: string,
    public type: DrawRewardTypeEnum,
    public quantity: number,
    public creditValuePence: number | null,
    public singleFuelPence: number | null = null,
    public dualFuelPence: number | null = null,
  ) {}

  get projectedCostPence(): number | null {
    if (this.creditValuePence !== null) {
      return this.quantity * this.creditValuePence
    }
    // Year of Energy has no single credit value; it pays a flat single- or
    // dual-fuel amount per winner, so project the dual-fuel ceiling.
    if (this.dualFuelPence !== null) {
      return this.quantity * this.dualFuelPence
    }
    return null
  }
}
